// blogTypeData.js
const defaultBlogTypeData = [
    {
        "frontend_component_blog_type_id": 1,
        "blog_type_hidden_name": false,
        "blog_type_id": 2922,
        "blog_type_name": "區塊標題呈現區",
        "frontend_column_frontend_component_blog_type_blog_data": [
            {
                "blog_type_blog_id": 1,
                "blog_id": 100,
                "title": "文章標題1",
                "content": "文章內容1",
                "annoucement_time": "2023-06-05T18:39:53.187227+08:00",
                "top": null,
                "top_edit_time": null,
                "blog_index": null,
                "more_content": "詳細資料１",
                "show": null,
                "external_link": "https://google.com",
                "youtube_iframe": null,
                "youtube_thumbnail": null,
                "property_json": null,
                "extermal_link_check": 1,
                "blog_type_classify_structure_type_blog_data": [
                    {
                        "classify_structure_type_blog_id": 12,
                        "classify_structure_type_id": 1876,
                        "file_id": null,
                        "file_client_name": "LINE_ALBUM_環境_230205_53.jp",
                        "upload_time": "2023-05-10",
                        "upload_user_name": "測試人員QB006",
                        "last_edit_time": "2023-05-10",
                        "last_edit_user_name": null
                    }
                ]
            },
            {
                "blog_type_blog_id": 1,
                "blog_id": 100,
                "title": "文章標題2",
                "content": "文章內容2",
                "annoucement_time": "2023-06-05T18:39:53.187227+08:00",
                "top": null,
                "top_edit_time": null,
                "blog_index": null,
                "more_content": "詳細資料２",
                "show": null,
                "external_link": "/",
                "youtube_iframe": null,
                "youtube_thumbnail": null,
                "property_json": null,
                "extermal_link_check": 0,
                "blog_type_classify_structure_type_blog_data": [
                    {
                        "classify_structure_type_blog_id": 12,
                        "classify_structure_type_id": 1876,
                        "file_id": null,
                        "file_client_name": "LINE_ALBUM_環境_230205_53.jp",
                        "upload_time": "2023-05-10",
                        "upload_user_name": "測試人員QB006",
                        "last_edit_time": "2023-05-10",
                        "last_edit_user_name": null
                    }
                ]
            },
            {
                "blog_type_blog_id": 1,
                "blog_id": 100,
                "title": "文章標題3",
                "content": "文章內容3",
                "annoucement_time": "2023-06-05T18:39:53.187227+08:00",
                "top": null,
                "top_edit_time": null,
                "blog_index": null,
                "more_content": "詳細資料３",
                "show": null,
                "external_link": null,
                "youtube_iframe": null,
                "youtube_thumbnail": null,
                "property_json": null,
                "extermal_link_check": null,
                "blog_type_classify_structure_type_blog_data": [
                    {
                        "classify_structure_type_blog_id": 12,
                        "classify_structure_type_id": 1876,
                        "file_id": null,
                        "file_client_name": "LINE_ALBUM_環境_230205_53.jp",
                        "upload_time": "2023-05-10",
                        "upload_user_name": "測試人員QB006",
                        "last_edit_time": "2023-05-10",
                        "last_edit_user_name": null
                    }
                ]
            },
            {
                "blog_type_blog_id": 1,
                "blog_id": 100,
                "title": "文章標題4",
                "content": "文章內容4",
                "annoucement_time": "2023-06-05T18:39:53.187227+08:00",
                "top": null,
                "top_edit_time": null,
                "blog_index": null,
                "more_content": "詳細資料４",
                "show": null,
                "external_link": null,
                "youtube_iframe": null,
                "youtube_thumbnail": null,
                "property_json": null,
                "extermal_link_check": null,
                "blog_type_classify_structure_type_blog_data": [
                    {
                        "classify_structure_type_blog_id": 12,
                        "classify_structure_type_id": 1876,
                        "file_id": null,
                        "file_client_name": "LINE_ALBUM_環境_230205_53.jp",
                        "upload_time": "2023-05-10",
                        "upload_user_name": "測試人員QB006",
                        "last_edit_time": "2023-05-10",
                        "last_edit_user_name": null
                    }
                ]

            },
        ]
    },
];

export default defaultBlogTypeData;
